"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuBarOption = void 0;
const Colors_1 = require("../../Colors");
exports.MenuBarOption = {
    titleIcon: {
        show: false,
        size: 30,
        color: Colors_1.Colors.pink,
        focus: Colors_1.Colors.p_blue,
    },
};
